import { modifyStringReplaceAll, removeSpecialCharacters } from '@libs/core';
import type { ProductCategory, ProductHit } from '@libs/algolia';
import type { ProductCategories } from '../types';

export const getPrimaryCategoryList = (
    primaryCategoryId?: string,
    categories?: ProductCategories
): ProductCategory[] => {
    if (!primaryCategoryId || !categories) {
        return [];
    }

    let categoriesToUse: ProductCategory[] = [];

    // find which list of categories is the primary one
    categories.forEach((subCategories: ProductCategory[]) => {
        subCategories.forEach((category: ProductCategory) => {
            if (category.id === primaryCategoryId) {
                categoriesToUse = subCategories;
            }
        });
    });

    return categoriesToUse;
};

const toUrlString = (url: string) => {
    const slug = modifyStringReplaceAll(
        removeSpecialCharacters(url, ['&', ' ']),
        {
            '&': 'and',
            ' - ': '-', // we add this to avoid the --- in the url
            '@': '',
            ' ': '-',
            ',': '',
            ';': '',
        }
    );
    return encodeURI(slug).toLocaleLowerCase();
};

export const categoryPath = (category: string) =>
    modifyStringReplaceAll(category, {
        '&': 'and',
        '@': '',
    }).toLocaleLowerCase();

export const getProductUrl = (product: ProductHit, useSkuId = false) => {
    const categories = getPrimaryCategoryList(
        product.primary_category_id,
        product.categories
    );
    // slice() ensures a new array is made so that we are not mutating it with reverse() was causing a hydration issue
    const categoryHierarchy = categories
        .slice()
        .reverse()
        .reduce(
            (acc: string, category: ProductCategory) =>
                `${acc}/${categoryPath(toUrlString(category.name.default))}`,
            ''
        );

    const productName = toUrlString(product?.name || '');
    const productIdOrSku = useSkuId ? product.id : product.masterProductID;
    return `${categoryHierarchy}/${productName}-${productIdOrSku}.html`;
};
